/**
 * This package's translations, registered at import.
 *
 * French and English, like every product feature: the product is French (§6 of
 * `docs/product/cadrage-hardauto.md`) and English is the parity reference.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "orders";

registerNamespace(NAMESPACE, { en, fr });
